import { LoadingOutlined } from "@ant-design/icons";
import { useOne } from "@refinedev/core";
import { Spin } from "antd";
import { MediaAsset } from "pages/media/types";
import { isVideo } from "../../../../helpers";
import { PicturePreview } from "pages/media/brandkit/components/PicturePreview";
import VideoPreview from "pages/media/brandkit/components/VideoPreview";
import { ASSET_STALE_TIME } from "pages/media/constants";

export const MediaAssetPreview = ({
  asset,
  onClick,
  cardWidth = 150,
}: {
  asset: Partial<MediaAsset>;
  onClick?: (asset: Partial<MediaAsset>) => void;
  cardWidth?: number | string;
}) => {
  const { data: assetData, refetch: refreshAssetUrl } = useOne<MediaAsset>({
    resource: `media/media/assets`,
    id: asset.id,
    queryOptions: {
      enabled: Boolean(!asset.path && asset.id),
      refetchInterval(data) {
        if (!data) {
          return 3000;
        }
        return false;
      },
      staleTime: ASSET_STALE_TIME,
    },
    errorNotification() {
      return false;
    }, // hide errors
  });

  const handleRefreshAssetUrl = () => {
    refreshAssetUrl().catch((error) =>
      console.error("Error refreshing asset url", error)
    );
  };

  const newAsset = assetData?.data;
  const newAssetPath = assetData?.data?.path ?? asset.path;
  return (
    <>
      <Spin spinning={!newAssetPath} indicator={<LoadingOutlined />} />
      {newAssetPath && !isVideo(asset) && (
        <PicturePreview
          cardWidth={cardWidth}
          coverHeight={"fit-content"}
          image={newAssetPath}
          fileName={""}
          onCardClick={() => onClick?.(newAsset ?? asset)}
          meta={false}
          refreshImageUrl={handleRefreshAssetUrl}
        />
      )}
      {newAssetPath && isVideo(asset) && (
        <VideoPreview
          video={newAssetPath}
          height={"max-content"}
          width={cardWidth}
          minHeight="auto"
          fileName=""
          onCardClick={() => onClick?.(newAsset ?? asset)}
          restrictDowndoad={asset.category === "FromStockContent"}
          duration={asset.duration ?? undefined}
        />
      )}
    </>
  );
};
